import moment from "moment";
import React, { useState } from "react";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();
const fmt = require("indian-number-format");

export default function TradeCard({
  item,
  trade_delete,
  reload,
  userType,
  isSelected,
  toggleSelect,
}) {
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState([]);
  const [openVisible, setOpenVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [tpassword, setTpassword] = useState("");

  const col = (children, className = "") => (
    <div className={`${className} small `}>{children}</div>
  );

  const handleDelete = () => {
    select.push(item.id);
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      delete_select: select,
      tpassword: tpassword,
      type: "TRADE",
      admin: "1",
    };

    backend.delete(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        toast.success(r.message);
        reload();
      } else {
        toast.error(r.message);
      }
    });
  };

  const handleOpen = () => {
    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      tpassword: tpassword,
      open_id: item.id,
      user_id: item.user_id
    };

    backend.reopen(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        toast.success(r.message);
        reload();
      } else {
        toast.error(r.message);
      }
    });
  };

  const exchangeMap = {
    nse: "NSE",
    mcx: "MCX",
    fo: "NSE-OPTIONS",
    mcx_options: "MCX-OPTIONS",
    nse_cash: "NSE-EQUITY",
    comex_future: "COMEX",
    crypto_future: "CRYPTO",
    forex_future: "FOREX",
    us_stock: "US-STOCK",
    sgx: "SGX",
    index: "OTHERS",
    dgcx: "DGCX",
    ncdex: "NCDEX",
  };

  return (
    <div className="menuContainer addHight text">
      {trade_delete === 1 && userType === 1 && (
        <div className="menuSymbol pointer">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => toggleSelect(item.id)}
          />
        </div>
      )}

      {col(exchangeMap[item.script_type] || "--", "menuExchange small")}

      {col(item.symbol, "menuSymbol")}

      {col(
        item.script_type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM"),
        "menuExpiry",
      )}

      {col(item.qty, "menuBuyPrice")}

      {col(
        item.type === "NEW" || item.type === "ADDED"
          ? "--"
          : item.standing_rate,
        "menuBuyQty",
      )}

      {col(item.rate, "menuBuyQty")}

      {col(
        item.buy_sell == 0 ? "BUY" : "SELL",
        `menuSellQty ${item.buy_sell == 0 ? "buytext" : "selltext"}`,
      )}

      {col(fmt.format(parseFloat(item.new_deposit).toFixed(0)), "menuSellQty")}

      {col(fmt.format(parseFloat(item.amount).toFixed(0)), "menuSellQty")}

      {col(
        item.type,
        `menuSymbol ${item.type === "NEW"
          ? "primarytext"
          : item.type === "ADDED"
            ? "buytext"
            : "selltext"
        }`,
      )}

      {col(
        fmt.format(parseFloat(item.brokerage_user_amt).toFixed(0)),
        "menuSellQty selltext",
      )}

      {col(
        fmt.format(parseFloat(item.profit_loss).toFixed(0)),
        `menuOpen ${item.profit_loss > 0 ? "buytext" : "selltext"}`,
      )}

      {col(item.other ?? "-", "menuLtt extraSmall")}

      {col(
        <div className="flex flex-col items-center justify-center">
          <div className="extraSmall">
            {moment(item.date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">
            {moment(item.date_created).format("HH:mm:ss")}
          </div>
        </div>,
        "menuLtt",
      )}

      {col(item.trade_duration_minutes, "menuLtt")}

      {userType === 1 &&
        col(
          <button
            onClick={() => setOpenVisible(true)}
            className="dropbtnNavSub sell white"
          >
            OPEN
          </button>,
          "menuBuyPrice pointer",
        )}

      {trade_delete === 1 &&
        userType === 1 &&
        col(
          <button
            onClick={() => setDeleteVisible(true)}
            className="dropbtnNavSub sell white"
          >
            DELETE
          </button>,
          "menuBuyPrice pointer",
        )}

      {deleteVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setDeleteVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Clear Data</h3>
            <p className="customModalWarning">
              This action will delete user <b>{item.username}</b> trade{" "}
              <b>{item.symbol}</b> after backup.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setDeleteVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? "Deleting..." : "Confirm Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {openVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setOpenVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Open Trade</h3>
            <p className="customModalWarning">
              This action will open user <b>{item.username}</b> trade{" "}
              <b>{item.symbol}</b>.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setOpenVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={handleOpen}
                disabled={loading}
              >
                {loading ? "Opening..." : "Confirm Open"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
